import "./loading.css"

export default function Loading(props){
    return(
        <section className="section-rings">
            <div className="container-rings">
                <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <span className="loading">{props.content}</span>
                
            </div>
        </section>
        
    )
}